<template>
  <div>
    <Page :title="pageTitle">
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <div>
            <WidgetInstaller :widget="'google_badge'" />
            <FloatingWidgetCustomizer />
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Page from "../components/Common/Page";
import WidgetInstaller from "../components/Widget/WidgetInstaller.vue";
import FloatingWidgetCustomizer from "../components/Widget/FloatingWidgetCustomizer.vue";

export default {
  components: {
    Page,
    WidgetInstaller,
    FloatingWidgetCustomizer
  },
  data() {
    return {
      pageTitle: "Floating Widget"
    };
  }
};
</script>

<style lang="scss" scoped></style> 